import React from 'react';
import { Dropdown as BootstrapDropdown } from 'react-bootstrap';
import './DropdownSearch.css';
import { Search as SearchIcon } from 'react-feather';
import { translate } from '../../../translations';
import Search from '../../Search/Search';
import DialogFooter from '../../DialogFooter/DialogFooter';

export class DropdownSearch extends React.PureComponent {
    render() {
        const {
            value,
            placeholder,
            placeholderStyle,
            onSearchChange,
            onSearchSubmit,
            onSearchClear,
            closeDropdownOnSubmit,
            primaryFooterButtonText,
            primaryFooterButtonIcon,
            description,
        } = this.props.search;

        const { dropdownCloseFunction } = this.props;

        const handleSearchSubmitClick = () => {
            if (typeof onSearchSubmit === 'function') {
                onSearchSubmit();
            }
            if (closeDropdownOnSubmit) {
                dropdownCloseFunction();
            }
        };

        const dialogFooterButtons = [
            {
                text: translate('clear'),
                variant: 'secondary',
                disabled: !value,
                rightFloat: true,
                onButtonClick: onSearchClear,
            },
            {
                text: primaryFooterButtonText ?? translate('search'),
                // check explicitly for 'undefined' to retain ability to pass in 'null' value in order to remove icon
                icon: primaryFooterButtonIcon !== undefined ? primaryFooterButtonIcon : <SearchIcon className="dialogButtonIcon" size={16} />,
                variant: 'primary',
                disabled: !value,
                rightFloat: true,
                onButtonClick: handleSearchSubmitClick,
            },
        ];

        return (
            <BootstrapDropdown.Menu className={description ? 'dropdownSearchMenu withDescription' : 'dropdownSearchMenu'}>
                {description && <div className="dropdownSearchDescription">{description}</div>}
                <Search
                    multipleRows
                    showClearIcon
                    placeholder={placeholder}
                    placeholderStyle={placeholderStyle}
                    value={value}
                    onChange={onSearchChange}
                    autoComplete="none"
                />
                <DialogFooter buttons={dialogFooterButtons} />
            </BootstrapDropdown.Menu>
        );
    }
}

export default DropdownSearch;
